import React from 'react'
import NavMenu from './NavMenu'
import userStore from 'stores/userStore'

const NavMenuContainer = props => (
    <NavMenu authLogout={userStore.authLogout} {...props} />
)

export default NavMenuContainer